<template>
    <div>
        <h2 class="m-0">
            抱歉， 页面正在开发中...
            点击跳转到
            <a href="javascript:;" @click="goHome">首页</a>
        </h2>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                countDown: 5,
            }
        },
        methods: {
            goHome() {
                this.$router.push('/home/homepage')
            }
        },
        // created() {
        //     setInterval(() => {
        //         this.countDown > 0 ? this.countDown-- : this.$router.push('/home/homepage')
        //     }, 1000)
        // }
    }
</script>

<style lang="scss" scoped>

</style>